import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';

import { FaRegSave, FaTimes } from 'react-icons/fa';

const MaquininhaModal = ({ onClose, maquininha, onMaquininhaAtualizada }) => {
  const [tituloModal, setTituloModal] = useState("");
  const [formData, setFormData] = useState({
    apelido: '',
    serial: '',
    status: 'ativo'
  });

  useEffect(() => {
    if (maquininha != null) {
      setFormData({
        ...maquininha
      });
      setTituloModal('Editar Máquininha');
    } else {
      setTituloModal('Nova Máquininha');
    }
  }, [maquininha]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const camposObrigatorios = [
      { campo: 'apelido', label: 'Apelido' },
      { campo: 'serial', label: 'Número Serial' },
      { campo: 'status', label: 'Status' }
    ];

    const camposInvalidos = camposObrigatorios.filter(({ campo }) => {
      const valor = formData[campo];
      if (typeof valor === 'string') return !valor.trim();
      return !valor;
    });

    if (camposInvalidos.length > 0) {
      Swal.fire(
        'Erro',
        `Os seguintes campos são obrigatórios: ${camposInvalidos.map(c => c.label).join(', ')}`,
        'error'
      );
      return;
    }

    Swal.fire({
      title: "Carregando...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      if (maquininha != null) {
        await api.put(`/maquinas-pagamento/${maquininha.id}`, formData);
        Swal.fire('Sucesso', 'Máquininha atualizada com sucesso!', 'success');
      } else {
        await api.post('/maquinas-pagamento', formData);
        Swal.fire('Sucesso', 'Máquininha cadastrada com sucesso!', 'success');
      }

      onMaquininhaAtualizada();
      onClose();
    } catch (error) {
      Swal.close();
      Swal.fire('Erro', `${error.response.data.message}`, 'error');
    }
  };

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="fw-bold mt-2">{tituloModal}</h4>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="row mt-3">
                <div className="col-md-12">
                  <label htmlFor="apelido" className="form-label fw-bold">Apelido</label>
                  <input
                    type="text"
                    className="form-control"
                    id="apelido"
                    name="apelido"
                    value={formData.apelido}
                    onChange={handleChange}
                    placeholder="Digite o apelido da máquininha"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <label htmlFor="serial" className="form-label fw-bold">Número Serial</label>
                  <input
                    type="text"
                    className="form-control"
                    id="serial"
                    name="serial"
                    value={formData.serial}
                    onChange={handleChange}
                    placeholder="Digite o número serial"
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-12">
                  <label htmlFor="status" className="form-label fw-bold">Status</label>
                  <select
                    className="form-select"
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="ativo">Ativo</option>
                    <option value="inativo">Inativo</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div className="modal-footer">
            <div className="row">
              <div className="col-12 text-end">
                <button className="btn btn-outline-danger" type="button" onClick={onClose}>
                  <FaTimes /> Fechar
                </button>
                <button className="btn btn-custom-primary ms-2" type="button" onClick={handleSubmit}>
                  <FaRegSave /> Salvar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaquininhaModal; 